var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTableCellPencilWriting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4312 11.3743L8.04199 11.7161L8.38312 9.32622L14.5274 3.18198C14.799 2.91039 15.1673 2.75781 15.5514 2.75781C15.9355 2.75781 16.3038 2.91039 16.5754 3.18198C16.847 3.45358 16.9996 3.82193 16.9996 4.20602C16.9996 4.59011 16.847 4.95847 16.5754 5.23006L10.4312 11.3743Z",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5856 11.4491V16.2764C14.5856 16.5325 14.4839 16.778 14.3028 16.9591C14.1218 17.1401 13.8762 17.2419 13.6201 17.2419H3.96547C3.70941 17.2419 3.46384 17.1401 3.28278 16.9591C3.10172 16.778 3 16.5325 3 16.2764V6.62172C3 6.36566 3.10172 6.12009 3.28278 5.93903C3.46384 5.75797 3.70941 5.65625 3.96547 5.65625H8.7928",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTableCellPencilWriting);
export default __webpack_public_path__ + "static/media/icn_table_cell_Pencil_Writing.e53037cc155856974c7abb13cd00263f.svg";
export { ForwardRef as ReactComponent };